import React from "react";
import styles from "../styles/Header.module.css";
import { Nav, Navbar } from "react-bootstrap";
import logo from "../assets/img/karagroup.png";
import menu from "../assets/img/menuIcon.png";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <div>
      <div className={styles.container}>
        <Navbar className={styles.mainMenu} bg="transparent" expand="lg">
          <Navbar.Toggle aria-controls="basic-navbar-nav">
            <span>
              <img src={menu} width="35rem" />
            </span>
          </Navbar.Toggle>
          <Navbar.Collapse style={{ marginLeft: "7rem" }} id="basic-navbar-nav">
            <Nav className="mr-auto">
              <div
                style={{ marginRight: "-1.7rem" }}
                className={styles.dropdown}
              >
                <button
                  style={{
                    color: "black",
                    marginLeft: "1rem",
                    marginTop: "0.7rem",
                  }}
                  className={styles.dropbtn}
                >
                  آموزش
                </button>
                <div className={styles.dropdownContent}>
                  <Link to="">ویدیو های آموزشی</Link>
                  <Link to="">صندلی داغ</Link>
                  <Link to="">مقالات</Link>
                </div>
              </div>

              <Link to="/Services" className={styles.dropdown}>
                <button
                  style={{
                    color: "black",
                    marginLeft: "1rem",
                    marginTop: "0.7rem",
                  }}
                  className={styles.dropbtn}
                >
                  کریپتو همراه
                </button>
                <div className={styles.dropdownContent}>
                  <Link to="">همراه حامی</Link>
                  <Link to="">همراه متخصص</Link>
                  <Link to="">همراه رهیاب</Link>
                </div>
              </Link>
              <div
                style={{ marginRight: "-1.7rem" }}
                className={styles.dropdown}
              >
                <button
                  style={{
                    color: "black",
                    marginLeft: "1rem",
                    marginTop: "0.7rem",
                  }}
                  className={styles.dropbtn}
                >
                  دوره ها
                </button>
                <div className={styles.dropdownContent}>
                  <Link to="">دوره ها</Link>
                  <Link to="">وبینار ها</Link>
                </div>
              </div>
              <Link
                style={{
                  color: "black",
                  marginLeft: "1rem",
                  marginTop: "0.7rem",
                  textDecoration: "none",
                }}
                className={styles.navLink}
                to="/"
              >
                موقعیت های شغلی
              </Link>
              <Link
                style={{
                  color: "black",
                  marginLeft: "1rem",
                  marginTop: "0.7rem",
                  textDecoration: "none",
                }}
                className={styles.navLink}
                to="/"
              >
                موقعیت های آموزشی
              </Link>
              <div style={{ marginRight: "-1rem" }} className={styles.dropdown}>
                <button
                  style={{
                    color: "black",
                    marginLeft: "1rem",
                    marginTop: "0.7rem",
                  }}
                  className={styles.dropbtn}
                >
                  ارتباط با ما
                </button>
                <div className={styles.dropdownContent}>
                  <Link to="">تماس با ما</Link>
                  <Link to="">مشاوره تخصصی</Link>
                </div>
              </div>
              <button className={styles.button}>ورود و ثبت نام</button>
            </Nav>
          </Navbar.Collapse>
          <Navbar.Brand href="" className={styles.logo}>
            <img src={logo} alt="لوگو" className={styles.logoPicture} />
          </Navbar.Brand>
        </Navbar>
      </div>
    </div>
  );
};

export default Header;
